export var LoyaltyItemGroupType;
(function(LoyaltyItemGroupType) {
    LoyaltyItemGroupType[/**
     * Group for custom items.
     *
     * @remarks
     * For item groups that are not a system item group in Vista Loyalty.
     */ "Custom"] = "Custom";
    LoyaltyItemGroupType[/**
     * Group for ticket items.
     *
     * @remarks
     * Known as 'BoxOffice' in Vista Loyalty.
     */ "Ticket"] = "Ticket";
    LoyaltyItemGroupType[/**
     * Group for concession items.
     *
     * @remarks
     * Known as 'Concessions' in Vista Loyalty.
     */ "Item"] = "Item";
    LoyaltyItemGroupType[/**
     * Group for discount items.
     */ "Discount"] = "Discount";
})(LoyaltyItemGroupType || (LoyaltyItemGroupType = {}));

//# sourceMappingURL=loyalty-item-group-type.js.map